import request from './request'

/**
 * 登录接口
 * @param {Object} data {username:"",password:""}
 */
export function loginApi(data) {
    return request({
        url: '/user/login',
        method: 'post',
        data
    })
}

/**
 * 注册接口
 * @param {Object} data {username:"",password:""}
 */
export function registerApi(data) {
    return request({
        url: '/user/register',
        method: 'post',
        data
    })
}